module.exports = __webpack_public_path__ + "img/arrow_line.84b617fd.svg";